<template>
  <div v-if="ready">
    <router-view />
  </div>
  <div v-else>
    Carregando...
  </div>
</template>

<script>
export default {
  data() {
    return {
      isMenuOpen: false
    };
  },
  computed: {
    ready() {
      return this.$auth.ready();
    }
  }
};
</script>

<style lang="scss">
// Import Bulma and Buefy styles
@import "./assets/scss/app.scss";
</style>
